// removed by extract-text-webpack-plugin
module.exports = {"radio":"radio__T5CXVvzc","radio_item":"radio_item__i6HKD7Hw","checked":"checked__18Xg9rey"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYRadio/index.module.less
// module id = 704
// module chunks = 1